import { render, staticRenderFns } from "./BrbLabelValue.vue?vue&type=template&id=65fe9bbe&"
import script from "./BrbLabelValue.vue?vue&type=script&lang=js&"
export * from "./BrbLabelValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fe9bbe')) {
      api.createRecord('65fe9bbe', component.options)
    } else {
      api.reload('65fe9bbe', component.options)
    }
    module.hot.accept("./BrbLabelValue.vue?vue&type=template&id=65fe9bbe&", function () {
      api.rerender('65fe9bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbLabelValue.vue"
export default component.exports